export const EPaymentProcessor = {
  Checkbook: "checkbook",
  TreasuryPrime: "treasury-prime",
} as const;

export type EPaymentProcessor =
  (typeof EPaymentProcessor)[keyof typeof EPaymentProcessor];
